import styled from 'styled-components';

export const Description = styled.p`
    margin: 32px 0px;
    text-align: justify;
`;
